import { render, staticRenderFns } from "./DashboardLayoutMyaffilEdit.vue?vue&type=template&id=622ec3f8&"
import script from "./DashboardLayoutMyaffilEdit.vue?vue&type=script&lang=js&"
export * from "./DashboardLayoutMyaffilEdit.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLayoutMyaffilEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports